import React from "react";

function SectionWhyNeedParaphraser() {
  return (
    <div className="container text-center" style={{ marginTop: "7rem" }}>
      {/* Title section */}
      <div>
        {/* Advantages of Humanizing Text */}
        <h1 className="display-6">Advantages of using our Paraphrasing Tool</h1>
      </div>

      {/* Description section */}
      <div>
        <h5 className="mt-4">Avoiding Plagiarism ↓</h5>
        <p className="lead">
          Rewriting content in a fresh way so it’s original while keeping the
          meaning intact.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Improving Clarity ↓</h5>
        <p className="lead">
          Making sentences simpler, more readable, or better suited to the
          target audience.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Adapting Tone & Style ↓</h5>
        <p className="lead">
          Adjusting formal, casual, or creative tone based on where and how the
          text will be used.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Saving Time ↓</h5>
        <p className="lead">
          Quickly rephrasing large chunks of text without having to start from
          scratch.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Enhancing SEO ↓</h5>
        <p className="lead">
          Creating unique versions of content to improve search engine ranking.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Language Learning ↓</h5>
        <p className="lead">
          Helping students and non-native speakers understand different ways to express the same idea.ƒ
        </p>
      </div>
    </div>
  );
}

export default SectionWhyNeedParaphraser;
